// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Af-z","bodyOpen":"Bf-z","content":"Cf-z","header":"Df-z","close":"Ef-z","closeNoHeading":"Ff-z"};